import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk/format';
import { View } from 'react-native';
import CalendarModal from '../../../components/common/calendar-modal';
import GenericDateSelectionBar from '../../../components/common/date-selection-bar';
import datesAreEqual from 'date-fns/is_equal';
import { format } from 'date-fns';
import styles from './date-selection-bar.styles';
import SimpleDate from '../../../components/common/date';
import Text from '@dbk/ui-text';
// import Text from '../../../components/common/text';
var languageCode = 'en';

function currentDateText(fromDate, toDate, messages, customDate) {
  if (fromDate == toDate) {
    if (customDate) {
      return (<> </>);
    }
    else {
      return (
        <div tabIndex={0}>
          <Text secondary> {messages['app.maturities.dateSelectionBar.currentlyShowing.singleLanguage']} <SimpleDate value={fromDate} month='long' renderProps={{ size: 'normal'}}/></Text>
        </div>
      );
    }
  }

  return (
    <div tabIndex={0}>
      <Text secondary> {messages['app.maturities.dateSelectionBar.currentlyShowing.multipleLanguage']} <SimpleDate value={fromDate} month='long' renderProps={{ size: 'normal'}}/> {messages['app.common.to']} <SimpleDate value={toDate} month='long' renderProps={{ size: 'normal'}}/> </Text>
    </div>
  );
}

function DateSelectionBar({
  maturities: {
    calendar,
    maturityDates,
    fromDate,
    toDate,
    customDate
  },
  messages,
  ...props
}) {
  const dteFrom = Date.parse(fromDate);
  const dteTo = Date.parse(toDate);
  const maturityDatesObj = (maturityDates ? JSON.parse(maturityDates) : []);
  const { auth: { langCode }} = props;
  if (props.auth.langCode && props.auth.langCode != null) {
    languageCode = props.auth.langCode.toLowerCase();
  }
  return (
    <View testID="date-selection-bar" style={styles.root}>
      <CalendarModal
        numberOfFutureMonth={12}
        calendarModal={calendar}
        highlightDays={maturityDatesObj}
        messages={messages}
        scrollOnce={false}
        languageCode={languageCode}
      />
      <GenericDateSelectionBar
        text={currentDateText(format(new Date(dteFrom), 'dd MMM yyyy'),
          format(new Date(dteTo), 'dd MMM yyyy'), messages, customDate)}
        isEditable={false}
        onEditPress={() => calendar.open()}
      />
    </View>
  );
}

DateSelectionBar.propTypes = {
  maturities: PropTypes.shape({
    calendar: PropTypes.object.isRequired,
    fromDate: PropTypes.string,
    toDate: PropTypes.string,
  }),
};

export default createContainer({
  $queries: {
    auth: {
      langCode: true,
    },
  },
  $fragments: {
    maturities: {
      calendar: {
        open: { $call: 'open' },
        ...CalendarModal.getFragment('calendarModal'),
      },
      maturityDates: true,
      fromDate: true,
      toDate: true,
      customDate: true,
    },
  },
})(pure(DateSelectionBar));
export { DateSelectionBar };
